import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
export const showLoginForm = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLoginForm.url(options),
    method: 'get',
})

showLoginForm.definition = {
    methods: ["get","head"],
    url: '/user/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
showLoginForm.url = (options?: RouteQueryOptions) => {
    return showLoginForm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
showLoginForm.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLoginForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
showLoginForm.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showLoginForm.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
const showLoginFormForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
showLoginFormForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::showLoginForm
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:34
* @route '/user/login'
*/
showLoginFormForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginForm.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showLoginForm.form = showLoginFormForm

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::login
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:50
* @route '/user/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

login.definition = {
    methods: ["post"],
    url: '/user/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::login
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:50
* @route '/user/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::login
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:50
* @route '/user/login'
*/
login.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::login
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:50
* @route '/user/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: login.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::login
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:50
* @route '/user/login'
*/
loginForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: login.url(options),
    method: 'post',
})

login.form = loginForm

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

logout.definition = {
    methods: ["get","head"],
    url: '/user/logout',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
logout.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
logout.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: logout.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
logoutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\LoginInertiaController::logout
* @see app/Http/Controllers/User/Auth/LoginInertiaController.php:130
* @route '/user/logout'
*/
logoutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logout.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

logout.form = logoutForm

const LoginInertiaController = { showLoginForm, login, logout }

export default LoginInertiaController